<template>
  <div id="srarchBaby">
    <div ref="searchBox" class="searchBox">
      <div class="search-input">
        <van-search
          ref="search"
          v-model="searchText"
          :left-icon="require('@/assets/images/community/search-icon.png')"
          :placeholder="placeholder"
          class="vanSearch"
          maxlength="50"
          shape="round"
          @clear="clear"
          @focus="searchFocus"
          @input="searchInput"
          @blur="searchBlur"
          @search="onSearch"
        />
        <span class="canBtn" @click="onSearch">搜索</span>
      </div>
      <div class="search-backicon" @click="handleBack">取消</div>
    </div>
  </div>
</template>

<script>
import { xmhh5CommunityClick_fn } from "@/assets/js/BuriedPointEvent";
export default {
  components: {},
  data() {
    return {
      searchText: "",
      disabled: false,
      placeholder: "",
      readonly: "",
      isTirm2: this.isTrim
    };
  },
  props:{
    isTrim:{
      type: Boolean,
      default: false
    }
  },
  // 监听属性 类似于data概念
  computed: {},
  // 监控data中的数据变化
  watch: {},
  // 方法集合
  methods: {
    onSearch() {
      this.searchText = this.searchText.split(' ').join('')
      this.$emit("onSearch",this.searchText,this.isTirm2)
      xmhh5CommunityClick_fn("xmhh5CommunityClick", {
        xmhh5_Community_Search_Click: "搜索页-搜索按钮",
      })
    },
    searchFocus() {
      console.log(222);
    },
    searchInput() {
      this.isTirm2 = true
      console.log(222, this.isTirm2);
    },
    searchBlur(){
      window.scroll(0,0);
    },
    clear() {
      console.log(222);
    },
    handleBack() {
      this.$refs.search.blur()
      setTimeout(()=>{
        this.searchText = ""
        if (window.history.length > 1) {
          this.$router.back(-1);
        } else {
          this.$router.push({ path: "/communityIndex" });
        }
        xmhh5CommunityClick_fn("xmhh5CommunityClick", {
          xmhh5_Community_Search_Click: "搜索页-取消",
        })

      }, 200)

    },
  },
  // 生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    this.$nextTick(()=>{
      this.$refs.search.querySelector('input').focus()
    })
    this.placeholder = this.$route.query.hot  ? this.$route.query.hot : "搜索"
    this.placeholder = this.placeholder.length > 13 ?  this.placeholder.slice(0,13) + "..." : this.placeholder
  },
};
</script>
<style lang="less" scoped>
#srarchBaby {
  .searchBox {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 12px 20px 0 12px;

    .search-backicon {
      // width: 32px;
      height: 23px;
      font-size: 16px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #999999;
      margin-right: 4px;
    }

    .van-search__action {
      font-size: @indexFontSize14;
    }

    .van-field__control {
      padding-right: 2px;
    }
    /deep/ .van-field__body{
      width: 100%;
    }
    .search-input {
      // flex: 1;
      width: 279px;
      height: 26px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 2px 2px 2px 10px;
      border-radius: 20px;
      border: 1px solid #F3A0D7;
      // margin-left: 12px;

      .vanSearch {
        /deep/ .van-icon {
          // font-size: 20px;

          .van-icon__image {
            width: 16px;
            height: 16px;
          }
        }
        /deep/ .van-icon-clear:before {
          display: inline-block;
          width: 22px;
          height: 22px;
          content: "";
          background: url("../../../assets/images/community/clearhot.png") no-repeat 0 2px;
          background-size: 100%;

          .van-icon__image {
            width: 22px;
            height: 22px;
          }
        }
      }

      .van-search {
        flex: 1;
        padding: 0;
        height: 26px;
        .van-search__content {
          padding-left: 0;
          background: none;
          display: flex;
          align-items: center;
          height: 100%;

          .van-cell {
            background: none;
            padding-right: 0;
            height: 100%;
            display: flex;
            align-items: center;
          }
        }

        .van-search__action {
          font-size: @indexFontSize13;
        }

        /deep/ .van-field__control {
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #000000;
          // margin-top: 2px;÷
          display: flex;
          align-items: center;
        }

        /deep/ input {
          text-overflow: ellipsis;
          overflow: hidden;
          white-space: nowrap;
        }
        input::-webkit-input-placeholder {
          color: #F973B7;
        }
      }

      .canBtn {
        width: 48px;
        height: 24px;
        text-align: center;
        background: linear-gradient(90deg, #FF76AE 0%, #CA56FF 100%);
        border-radius: 18px;
        font-size: 12px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #FFFFFF;
        line-height: 24px;
        margin-left: 8px;
        margin-right: 2px;
      }
    }

    // @media screen and (max-width: 640px) {
    //   .van-search {
    //     width: 291px;
    //     padding: 12px 0;
    // 
    // }
   /deep/ .van-field__left-icon{
     margin-right: 0px;
    }
    /deep/ .van-field__value{
    //  padding-top: 1px;
      display: flex;
      align-items: center;
    }
  }
}
</style>
